@if (avatar()) {
  <div class="avatar-container" [ngStyle]="{ width: avatar()?.size + 'px', height: avatar()?.size + 'px' }">
    @if (avatar()?.routeEnabled) {
      <a
        class="avatar"
        (click)="routeTo()"
        [class.notification]="avatar()?.hasNotification"
        [ngStyle]="{ 'border-color': avatar()?.borderColour }"
      >
        @if (avatar()?.pictureUrl && avatar()?.pictureUrl !== '') {
          @if (avatar()?.pictureUrl | authImageUrl | async; as imageUrl) {
            @if (imageUrl) {
              <img
                [src]="imageUrl"
                [width]="avatar()?.size"
                [height]="avatar()?.size"
                class="avatar-image"
                alt="User avatar"
              />
            } @else {
              <app-placeholder-picture
                [isGuardian]="avatar()?.isGuardian || false"
                [colour]="avatar()?.borderColour ?? ''"
                [size]="avatar()?.isGuardian ? (avatar()?.size ?? 64) - 8 : 56"
              />
            }
          } @else {
            <app-placeholder-picture
              [isGuardian]="avatar()?.isGuardian || false"
              [colour]="avatar()?.borderColour ?? ''"
              [size]="(avatar()?.size ?? 64) - 8"
            />
          }
        } @else {
          <app-placeholder-picture
            [isGuardian]="avatar()?.isGuardian || false"
            [colour]="avatar()?.borderColour ?? ''"
            [size]="avatar()?.isGuardian ? (avatar()?.size ?? 64) - 8 : 56"
          />
        }
        @if (avatar()?.enrolmentPercent !== null && (avatar()?.enrolmentPercent ?? 100) < 100) {
          <svg width="72" height="72" viewBox="0 0 40 40" class="circular-chart">
            <circle class="circle-bg" cx="20" cy="20" r="19" [attr.stroke]="adjustedColor" />
            @if (calculateCircumference(); as circle) {
              <circle
                class="circle"
                cx="20"
                cy="20"
                r="19"
                [attr.stroke-dasharray]="circle.circumference"
                [attr.stroke-dashoffset]="circle.offset"
                [attr.stroke]="avatar()?.borderColour"
              />
            }
          </svg>
        }
      </a>
    } @else {
      <div
        class="avatar"
        [class.notification]="avatar()?.hasNotification"
        [ngStyle]="{ 'border-color': avatar()?.borderColour }"
      >
        @if (avatar()?.pictureUrl && avatar()?.pictureUrl !== '') {
          @if (avatar()?.pictureUrl | authImageUrl | async; as imageUrl) {
            @if (imageUrl) {
              <img
                [src]="imageUrl"
                [width]="avatar()?.size"
                [height]="avatar()?.size"
                class="avatar-image"
                alt="User avatar"
              />
            } @else {
              <app-placeholder-picture
                [isGuardian]="avatar()?.isGuardian || false"
                [colour]="avatar()?.borderColour ?? ''"
                [size]="(avatar()?.size ?? 64) - 8"
              />
            }
          } @else {
            <app-placeholder-picture
              [isGuardian]="avatar()?.isGuardian || false"
              [colour]="avatar()?.borderColour ?? ''"
              [size]="(avatar()?.size ?? 64) - 8"
            />
          }
        } @else {
          <app-placeholder-picture
            [isGuardian]="avatar()?.isGuardian || false"
            [colour]="avatar()?.borderColour ?? ''"
            [size]="(avatar()?.size ?? 64) - 8"
          />
        }
      </div>
    }
  </div>
}
